import { ActiveDomain } from "stores/RootStore";

/**
 *
 * @param location The current pathname. Should be in the form `/path/to/thing`
 */
export function resolveDomainFromLocation(location: string) {
    let leadingAndTrailingSlashesRemoved = location;
    if (location.startsWith("/"))
        leadingAndTrailingSlashesRemoved =
            leadingAndTrailingSlashesRemoved.substring(1);
    if (location.endsWith("/"))
        leadingAndTrailingSlashesRemoved =
            leadingAndTrailingSlashesRemoved.substring(
                0,
                leadingAndTrailingSlashesRemoved.length - 1,
            );
    const individualPathParts = leadingAndTrailingSlashesRemoved.split("/");
    if (individualPathParts.length === 0) return;

    const [appOrActiveDomain, appActiveDomain] = individualPathParts;

    let domainString;
    const isAppPath = appOrActiveDomain === "app";
    if (isAppPath) {
        domainString = appActiveDomain;
    } else {
        domainString = appOrActiveDomain;
    }

    switch (domainString) {
        case "conversations":
            // meaning ['app', 'conversations', 'convo-id']
            if (individualPathParts.length === 3)
                return ActiveDomain.Conversation;
            return ActiveDomain.Conversations;
        case "signals":
            return ActiveDomain.Signals;
        case "evaluation":
            return ActiveDomain.Evaluation;
        case "agentcoaching":
            return ActiveDomain.AgentCoaching;
        default:
            return undefined;
    }
}
